// Moyens de paiement proposés au donateur.
//
// Mêmes règles que la page de paiement commune (components/paiement/index.js) : elles
// dépendent de l'organisation, de l'association qui encaisse et de la devise. Module
// pur, testé : proposer un moyen non configuré mène le donateur à une impasse, en
// oublier un lui coûte son don.
//
// Nedarim Plus n'est jamais une option : c'est la passerelle carte du côté serveur,
// reconnue à la réponse (paiement dans un cadre au lieu d'une redirection).

import { isKesherBitEnabled } from "../../../../components/paiement/kesherEligibility.cjs";
import { isSepaXmlEnabledFor } from "../../../../components/sepa_xml/paymentCheckout";

/**
 * @param {object} input {org, assoc, assocInfo, devise, recurrent}
 * @returns {Array<{value:string, label:string, image?:string}>}
 */
export function platformOptions({ org = {}, assoc = "MAIN", assocInfo = null, devise = "eur", recurrent = false }) {
    const config = Array.isArray(org.config) ? org.config : [];
    const has = (key) => config.some(item => item?.key === key && item?.assoc === assoc);
    const options = [];
    const sepa = recurrent && String(devise).toLowerCase() === 'eur' && isSepaXmlEnabledFor(org, assoc);
    if (recurrent && org.web?.['paiement.platform.recurrent'] === 'SEPA_XML') {
        return sepa ? [{value: 'SEPA_XML', label: 'SEPA', image: 'compte-bancaire.png'}] : [];
    }

    // La carte bancaire est toujours proposée, en ponctuel comme en récurrent.
    options.push({ value: "CARD", label: "CARD", image: "carte-bancaire.png" });
    if (sepa) options.push({value: 'SEPA_XML', label: 'SEPA', image: 'compte-bancaire.png'});

    if (recurrent && has("GCL")) {
        options.push({ value: "PRELEVEMENT.GOCARDLESS", label: "SEPA", image: "compte-bancaire.png" });
    }
    if (recurrent && has("STRIPE.SEPA_PAIEMENT_METHOD")) {
        options.push({ value: "STRIPE.SEPA", label: "SEPA", image: "compte-bancaire.png" });
    }
    if (!recurrent && has("PAYPAL_PAIEMENT_METHOD")) {
        options.push({ value: "PAYPAL", label: "PAYPAL", image: "paypal.png" });
    }
    if (!recurrent && assocInfo?._format === "IL" && has("CARDCOM.BIT_PAIEMENT_METHOD")) {
        options.push({ value: "CARDCOM.BIT", label: "BIT" });
    }
    if (!recurrent && assocInfo?._format === "IL" && isKesherBitEnabled(org, assoc, devise)) {
        options.push({ value: "KESHER.BIT", label: "Bit", image: "bit.jpg" });
    }
    // Achisomoch : Royaume-Uni, livres sterling, jamais en récurrent.
    if (!recurrent && String(devise).toLowerCase() === "gbp" && has("AAC_PAIEMENT_METHOD")) {
        options.push({ value: "AAC", label: "AAC", image: "aac.png" });
    }

    return options;
}

/** Association qui encaisse réellement, telle que la page commune la résout. */
export function assocInfoOf(org = {}, assoc = "MAIN") {
    const list = Array.isArray(org.cerfasInfos) ? org.cerfasInfos : [];
    return list.find(item => item?.id === assoc || item?.value === assoc) || null;
}
